import { bD as ae, bp as J, bq as $, bE as xt, bF as Ce, bu as a, bs as vt, br as Ct, bt as c } from "./helpers-458d7e27.js";
import ue, { forwardRef as Dn, useRef as pe, useMemo as de, useState as ye, useContext as yt, useEffect as $n } from "react";
import { CriticalIcon as _t, CheckmarkBackgroundIcon as Ot } from "@paypalcorp/pp-react-icons";
import { useTheme as be, jsx as C, ClassNames as It, css as l } from "@emotion/react";
var St = ue.createContext(null);
function Ee(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function Fe(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ee(Object(t), !0).forEach(function(o) {
      ae(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ee(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
var wt = function(e, n, t, o) {
  return t ? e && e.messageFormatter ? e.messageFormatter({
    id: t
  }).format(o) : t : n;
}, Xt = function(e, n, t) {
  if (e && e.currencyFormatter) {
    var o = e.currencyFormatter({
      currency: t
    }), d = o.formatToParts(1e3), b = Lt(d), g = b.intlMaskOptions, u = b.intlCurrencyPrefix, i = b.intlCurrencySuffix, r = o.resolvedOptions();
    return r.maximumFractionDigits === 0 && (g.padFractionalZeros = !1, g.scale = 0), {
      currencyMaskOptions: Fe(Fe({
        padFractionalZeros: !0
      }, g), n),
      intlCurrencyPrefix: u,
      intlCurrencySuffix: i
    };
  }
  return {
    currencyMaskOptions: n
  };
};
function Lt(e) {
  var n = {
    mask: Number
  }, t = "", o = "";
  return e.forEach(function(d, b) {
    var g = d.type, u = d.value;
    switch (g) {
      case "currencySymbol":
        b === 0 ? t = u : o = u;
        break;
      case "currency":
        b === 0 ? t = u : o = u;
        break;
      case "group":
        n.thousandsSeparator = u;
        break;
      case "fraction":
        n.scale = u.length;
        break;
      case "decimal":
        n.radix = u;
        break;
    }
  }), {
    intlMaskOptions: n,
    intlCurrencyPrefix: t,
    intlCurrencySuffix: o
  };
}
var Re, Ae, Pe, Be, ke, He, De, $e, Me, ze, Xe, Ve, Ke, Ze, qe, Ue, Ge, Je, Qe, Ye, en, nn, tn, rn, an, on, cn, ln, sn, pn, un, dn, bn, fn, hn, gn, mn, xn, vn, Cn, yn, _n, On, In, Sn, wn, Ln, Wn, Tn, Nn, jn, En, Fn, Rn, An, Pn, Bn;
function fe(e) {
  if (!Object.keys(e).length)
    return console.warn("Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react."), {};
  var n = e.sysBorderThicknessNormal, t = e.sysBorderThicknessEmphasis, o = e.sysBorderRadiusSm, d = e.sysColorBackgroundSurface, b = e.sysColorBackgroundMediumContrast, g = e.sysSpaceTiny, u = e.sysSpaceXs, i = e.sysSpaceSm, r = e.sysSpaceMd, p = e.sysSpaceXl, O = e.sysMotionDurationHover, h = e.sysSizeTapTargetDefault, v = e.sysColorStructureBorderHighContrast, y = e.sysColorErrorMain, S = e.sysColorSuccessMain, _ = e.sysTypographyBodyLineHeight, m = e.sysTypographyCaptionLineHeight, w = e.sysColorBackgroundHighContrast, s = e.sysSizeFieldLg, f = a("(".concat(s, " - ").concat(_, ") / 2")), L = a("(".concat(s, " - ").concat(_, ") / 2")), I = a("".concat(s, " - ").concat(i, " - ").concat(m, " - ").concat(g, " - ").concat(_)), j = a("4rem - 0.125rem"), T = vt(e), N = T.focusStyles, M = T.ellipsis, k = T.screenReader, E = Ct(e), H = E.caption, P = E.body, D = E.fieldLabelSm, F = N.stateFocusBorderColorInner, B = N.stateFocusBorderWidthInner, X = N.stateFocusBorderColorOuter, V = N.stateFocusBorderWidthOuter, K = N.stateErrorFocusBorderColorOuter, Z = N.stateErrorFocusBorderColorInner;
  function q() {
    return l(Re || (Re = c([`
      border-color: `, `;
      box-shadow: 0 0 0
          `, `
          `, ` inset,
        0 0 0 `, " ", `;
    `])), F, a("".concat(B, " - ").concat(n)), F, V, X);
  }
  function R() {
    return l(Ae || (Ae = c([`
      border-width: `, `;
      border-color: `, `;
      box-shadow: 0 0 0
          `, `
          `, ` inset,
        0 0 0 `, " ", `;
    `])), t, Z, a("".concat(B, " - ").concat(t)), Z, V, K);
  }
  function he() {
    return l(Pe || (Pe = c([`
      `, `;
      display: flex;
      margin: `, ` 0 0;
    `])), H({
      color: b
    }), u);
  }
  function U() {
    return l(Be || (Be = c([`
      text-decoration: none;
      position: absolute;
    `])));
  }
  var oe = l(ke || (ke = c([`
    label: label;
    `, `
    `, `;
    pointer-events: none;
    position: absolute;
    top: `, `;
    transition: font-size `, ` ease-in-out,
      top `, ` ease-in-out,
      background-color 10ms `, ` linear;
    right: `, `;
    left: `, `;
    background-clip: padding-box;
  `])), D({
    color: b
  }), M, i, O, O, O, r, r), ce = l(He || (He = c([`
    label: label_placeholder_shown_and_not_focused;
    :placeholder-shown:not(:focus) ~ label {
      `, `;
      top: `, `;
      background-color: transparent;
      margin-bottom: 0;
    }
  `])), P({
    color: b
  }), f), _e = l(De || (De = c([`
    label: label_screenreader;
    `, `
  `])), k), Oe = l($e || ($e = c([`
    label: helper_text;
    `, `
    display: block;
    list-style: none;
    padding: 0;
    overflow-wrap: break-word;
  `])), he()), W = l(Me || (Me = c([`
    label: text_input_base;
    `, `;
    padding: 0;
    position: relative;
    text-align: left;
    [dir='rtl'] & {
      text-align: right;
    }
  `])), P()), x = l(ze || (ze = c([`
    label: icon_right;
    `, `
    width: `, `;
    height: `, `;
    display: flex;
    justify-content: center;
    align-items: center;
    top: `, `;
    right: `, `;
    left: auto;
    [dir='rtl'] & {
      left: `, `;
      right: auto;
    }
  `])), U(), h, h, i, i, i), G = l(Xe || (Xe = c([`
    label: icon_left;
    pointer-events: none;
    z-index: 1;
    `, `
    inset: `, " auto ", " ", `;
    color: `, `;
    [dir='rtl'] & {
      inset: `, " ", " ", ` auto;
    }
  `])), U(), f, f, r, b, f, r, f), z = l(Ve || (Ve = c([`
    label: text_input_control;
    padding: `, `
      `, `
      `, `
      `, `;
    `, `;
    text-overflow: ellipsis;
    box-sizing: border-box;
    width: 100%;
    border: `, ` solid
      `, `;
    border-radius: `, `;
    background-color: `, `;
    &::placeholder {
      color: `, `;
    }
    &:placeholder-shown:not(:focus)::-webkit-input-placeholder {
      opacity: 0;
      transition: opacity `, ` ease-in-out;
    }
    &:placeholder-shown:not(:focus)::-moz-placeholder {
      opacity: 0;
      transition: opacity `, ` ease-in-out;
    }
    &:first-line {
      line-height: `, `;
    }
    &::-ms-reveal, &::-ms-clear{
      display: none;
    }

    margin: 0;
    outline: none;
    position: relative;

    &:focus {
      `, `;
    }

    -webkit-appearance: none;
    -moz-appearance: none;

    min-height: `, `; // Replace later
    &::-webkit-input-placeholder {
      color: `, `;
      opacity: 1;
    }
    &:-moz-placeholder {
      color: `, `;
      opacity: 1;
      transition: opacity `, ` ease-in-out;
    }
  `])), a("".concat(f, " + ").concat(i)), a("".concat(r, " - ").concat(n)), I, a("".concat(r, " - ").concat(n)), P(), v, n, o, d, b, O, O, _, q(), s, b, b, O), Q = l(Ke || (Ke = c([`
    label: no_label_text_input_control;
    padding: `, `
      `, `
      `, `
      `, `;
    &:placeholder-shown:not(:focus)::placeholder {
      opacity: 1;
    }
  `])), a("".concat(f, " - ").concat(n)), a("".concat(r, " - ").concat(n)), a("".concat(L, " - ").concat(n)), a("".concat(r, " - ").concat(n))), Y = l(Ze || (Ze = c([`
    label: error_text_input_control;
    border: `, " solid ", `;
    padding: `, `
      `, `
      `, `
      `, `;

    &:focus {
      `, `;
    }
  `])), t, y, a("".concat(f, " + ").concat(i, " - ").concat(t, " / 2")), a("".concat(r, " - ").concat(t)), a("".concat(I, " - ").concat(t, " / 2")), a("".concat(r, " - ").concat(t)), R()), A = l(qe || (qe = c([`
    label: text_input_control_error_with_icon_right;
    padding-right: `, `;
    padding-left: `, `;
    [dir='rtl'] & {
      padding-left: `, `;
      padding-right: `, `;
    }
  `])), a("".concat(r, ` +
      `).concat(h, " - ").concat(t)), a("".concat(r, ` -
      `).concat(t)), a("".concat(r, ` +
          `).concat(h, " - ").concat(t)), a("".concat(r, ` -
        `).concat(t))), ee = l(Ue || (Ue = c([`
    label: text_input_control_error_with_icon_left;
    padding-left: `, `;
    padding-right: `, `;
    [dir='rtl'] & {
      padding-right: `, `;
      padding-left: `, `;
    }
  `])), a("2 * ".concat(r, " + ").concat(p, ` -
      `).concat(t)), a("".concat(r, ` -
      `).concat(t)), a("2 * ".concat(r, " + ").concat(p, ` -
          `).concat(t)), a("".concat(r, ` -
          `).concat(t))), ne = l(Ge || (Ge = c([`
    label: text_input_control_error_with_icon_left_and_right;
    padding-right: `, `;
    padding-left: `, `;
    [dir='rtl'] & {
      padding-right: `, `;
      padding-left: `, `;
    }
  `])), a("".concat(r, ` +
      `).concat(h, " - ").concat(t)), a("2 * ".concat(r, " + ").concat(p, ` -
      `).concat(t)), a("2 * ".concat(r, " + ").concat(p, ` -
          `).concat(t)), a("".concat(r, ` +
          `).concat(h, " - ").concat(t))), te = l(Je || (Je = c([`
    label: no_label_text_input_control_error;
    padding: `, `
      `, `
      `, `
      `, `;
  `])), a("".concat(f, " - ").concat(t)), a("".concat(r, " - ").concat(t)), a("".concat(L, " - ").concat(t)), a("".concat(r, " - ").concat(t))), Ie = l(Qe || (Qe = c([`
    label: text_input_control_with_icon_right;
    padding-right: `, `;
    padding-left: `, `;
    [dir='rtl'] & {
      padding-left: `, `;
      padding-right: `, `;
    }
  `])), a("".concat(r, " + ").concat(i, " + ").concat(h, " - ").concat(n)), a("".concat(r, " - ").concat(n)), a("".concat(r, " + ").concat(i, " + ").concat(h, " - ").concat(n)), a("".concat(r, " - ").concat(n))), ge = l(Ye || (Ye = c([`
    label: text_input_control_with_icon_left;
    padding-left: `, `;
    padding-right: `, `;
    [dir='rtl'] & {
      padding-right: `, `;
      padding-left: `, `;
    }
  `])), a("2 * ".concat(r, " + ").concat(p, ` -
      `).concat(n)), a("".concat(r, ` -
      `).concat(n)), a("2 * ".concat(r, " + ").concat(p, ` -
        `).concat(n)), a("".concat(r, ` -
        `).concat(n))), le = l(en || (en = c([`
    label: text_input_control_with_icon_left_and_right;
    padding-left: `, `;
    padding-right: `, `;
    [dir='rtl'] & {
      padding-right: `, `;
      padding-left: `, `;
    }
  `])), a("2 * ".concat(r, " + ").concat(p, ` -
        `).concat(n)), a("".concat(r, ` +
        `).concat(h, " - ").concat(n)), a("2 * ".concat(r, " + ").concat(p, ` -
        `).concat(n)), a("".concat(r, ` +
          `).concat(h, " - ").concat(n))), Se = l(nn || (nn = c([`
    label: label_with_icon_right;
    left: `, `;
    right: `, `;
    [dir='rtl'] & {
      left: `, `;
      right: `, `;
    }
  `])), r, a("".concat(r, ` +
        `).concat(h)), a("".concat(r, " + ").concat(h)), r), we = l(tn || (tn = c([`
    label: label_with_icon_left;
    left: `, `;
    right: `, `;
    [dir='rtl'] & {
      right: `, `;
      left: `, `;
    }
  `])), a("2 * ".concat(r, " + ").concat(p)), r, a("2 * ".concat(r, " + ").concat(p)), r), Le = l(rn || (rn = c([`
    label: error_text;
    `, `
    align-items: center;
  `])), he()), We = l(an || (an = c([`
    label: error_icon;
    color: `, `;
    margin-right: `, `;
    margin-left: 0;
    align-self: flex-start;
    [dir='rtl'] & {
      margin-left: `, `;
      margin-right: 0;
    }
  `])), y, u, u), me = l(on || (on = c([`
    label: success_icon;
    color: `, `;
    margin-right: `, `;
    margin-left: initial;
    align-self: flex-start;
    [dir='rtl'] & {
      margin-left: `, `;
      margin-right: 0;
    }
  `])), S, u, u), re = l(cn || (cn = c([`
    label: multi_line_error;
    list-style: none;
    padding: 0;
    margin: 0;
  `]))), xe = l(ln || (ln = c([`
    label: prefix_wrapper;
    position: relative;
    display: flex;
    background-color: `, `;
    &:after {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      border: `, ` solid
        `, `;
      border-radius: `, `;
      pointer-events: none;
    }
    padding: `, `;
  `])), d, n, v, o, n), zn = l(sn || (sn = c([`
    label: prefix_wrapper_error;
    &:after {
      border: `, " solid ", `;
    }
    padding: `, " ", `;
  `])), t, y, n, t), Xn = l(pn || (pn = c([`
    label: prefix_wrapper_focus_error;
    &:after {
      `, `
    }
  `])), R()), ie = l(un || (un = c([`
    label: prefix_suffix;
    white-space: nowrap;
    color: `, `;
    padding: `, " ", `
      `, " ", `;
  `])), w, a("".concat(f, " + ").concat(i)), g, I, g), Vn = l(dn || (dn = c([`
    label: prefix_wrapper_control;
    border: none;
    min-height: `, `;
    &:focus {
      border: none;
      box-shadow: none;
      outline: none;
    }
    &:placeholder-shown:not(:focus) ~ div {
      opacity: 0;
    }
  `])), j), Kn = l(bn || (bn = c([`
    label: prefix;
    order: -1;
    `, `
    padding-left: `, `;
    [dir='rtl'] & {
      `, `
      padding-right: `, `;
    }
  `])), ie, r, ie, r), Zn = l(fn || (fn = c([`
    label: suffix;
    `, `
    padding-right: `, `;
    [dir='rtl'] & {
      `, `
      padding-left: `, `;
    }
  `])), ie, r, ie, r), qn = l(hn || (hn = c([`
    label: no_label_suffix_or_prefix;
    padding-top: `, `;
    padding-bottom: `, `;
    [dir='rtl'] & {
      padding-top: `, `;
      padding-bottom: `, `;
    }
  `])), a("".concat(f, " - ").concat(n)), a("".concat(L, " - ").concat(n)), a("".concat(f, " - ").concat(n)), a("".concat(L, " - ").concat(n))), Un = l(gn || (gn = c([`
    label: prefix_wrapper_control_with_prefix;
    padding-left: 0;
    [dir='rtl'] & {
      padding-right: 0;
      padding-left: `, `;
    }
  `])), r), Gn = l(mn || (mn = c([`
    label: prefix_wrapper_control_with_prefix;
    padding-right: 0;
    [dir='rtl'] & {
      padding-left: 0;
      padding-right: `, `;
    }
  `])), r), Jn = l(xn || (xn = c([`
    label: prefix_wrapper_control_with_prefix_suffix;
    padding-left: 0;
    padding-right: 0;
    [dir='rtl'] & {
      padding-left: 0;
      padding-right: 0;
    }
  `]))), Qn = l(vn || (vn = c([`
    label: prefix_wrapper_focus;
    &:after {
      `, `
    }
  `])), q()), Yn = l(Cn || (Cn = c([`
    label: text_area_control;
    height: auto;
    background-color: `, `;
    outline: none;
    box-shadow: none;
    resize: none;
    display: block;
    &:placeholder-shown:not(:focus) {
      ~ label {
        padding-top: 0;
      }
    }
    &:focus {
      ~ label {
        border-top: `, ` solid transparent;
        padding-top: `, `;
      }
    }
  `])), d, a("".concat(B, ` -
            `).concat(n)), a("".concat(i, ` -
            `).concat(B))), et = l(yn || (yn = c([`
    label: text_area_control_error;
    &:focus {
      ~ label {
        border-top: `, ` solid transparent;
      }
    }
  `])), a("".concat(B, ` -
          `).concat(t))), nt = l(_n || (_n = c([`
    label: text_area_control_label;
    background-color: `, `;
    top: `, `;
    padding-top: `, `;
  `])), d, n, a("".concat(i, ` -
        `).concat(n))), tt = l(On || (On = c([`
    label: text_area_control_error_label;
    top: `, `;
    padding-top: `, `;
  `])), t, a("".concat(i, ` -
      `).concat(t))), rt = l(In || (In = c([`
    label: text_area_counter_wrapper;
    cursor: text;
    position: relative;
    padding: `, `;
    &:after {
      content: ' ';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      border: `, ` solid
        `, `;
      border-radius: `, `;
      pointer-events: none;
    }
    textarea:focus,
    textarea:not(:focus) {
      border: none;
      outline: none;
      box-shadow: none;
    }
  `])), n, n, v, o), at = l(Sn || (Sn = c([`
    label: text_area_counter_wrapper_focus;
    &:after {
      `, `
    }
  `])), q()), ot = l(wn || (wn = c([`
    label: text_area_counter_text;
    `, `
    padding: `, `
      `, `
      `, `
      `, `;
    text-align: right;
    background-color: `, `;
    [dir='rtl'] & {
      text-align: left;
    }
  `])), H({
    color: b
  }), i, a("".concat(r, " - ").concat(n)), a("".concat(i, " - ").concat(n)), a("".concat(r, " - ").concat(n)), d), ct = l(Ln || (Ln = c([`
    label: text_area_error_counter_wrapper;
    padding-left: `, `;
    padding-right: `, `;

    &:after {
      border: `, " solid ", `;
    }
  `])), t, t, t, y), lt = l(Wn || (Wn = c([`
    label: text_area_error_counter_wrapper_focus;
    &:after {
      `, `
    }
  `])), R()), it = l(Tn || (Tn = c([`
    label: text_area_error_counter_text;
    color: `, `;
    padding-left: `, `;
    padding-right: `, `;
  `])), y, a("".concat(r, ` -
        `).concat(t)), a("".concat(r, ` -
        `).concat(t))), se = a("".concat(h, " + ").concat(r)), st = a("".concat(m, " + ").concat(g)), pt = l(Nn || (Nn = c([`
    label: text_display_no_label_control;
    padding-top: `, `;
    padding-bottom: `, `;
    padding-left: 0;
    [dir='rtl'] & {
      padding-left: `, `;
    }
  `])), r, r, se), ut = l(jn || (jn = c([`
    label: text_display_control;
    border: 0;
    padding-left: 0;
    padding-top: `, `;
    padding-bottom: 0;
    min-height: `, `;
    display: block;
    background-color: transparent;
    overflow-wrap: break-word;
    [dir='rtl'] & {
      padding-right: 0;
    }
  `])), st, "2.875rem"), dt = l(En || (En = c([`
    label: text_display_label;
    top: 0;
    left: 0;
    [dir='rtl'] & {
      left: `, `;
      right: 0;
    }
  `])), se), bt = l(Fn || (Fn = c([`
    label: text_display_icon_right;
    top: 0;
  `]))), ft = l(Rn || (Rn = c([`
    label: text_display_label_icon_right;
    right: `, `;
  `])), se), ht = l(An || (An = c([`
    label: text_display_control_icon_right;
    padding-right: `, `;

    [dir='rtl'] & {
      padding-left: `, `;
    }
  `])), a("".concat(se, " - ").concat(n)), a("".concat(se, " - ").concat(n))), gt = l(Pn || (Pn = c([`
    label: placemat;
    `, `
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    padding: `, `
      `, `
      `, `
      `, `;
    background-color: `, `;
    white-space: nowrap;
    & + input:focus {
      background-color: transparent;
    }
    [dir='rtl'] & {
      transform: translateX(-`, `);
    }
  `])), P({
    color: b
  }), a("".concat(f, " + ").concat(i, " + ").concat(n)), r, a("".concat(I, " + ").concat(n)), r, d, n), mt = l(Bn || (Bn = c([`
    label: no_label_placemat;
    padding-top: `, `;
  `])), f);
  return {
    label: oe,
    labelWithScreenreader: _e,
    helperText: Oe,
    base: W,
    iconRight: x,
    iconLeft: G,
    control: z,
    nolabelControl: Q,
    errorControl: Y,
    prefixWrapperError: zn,
    prefixWrapperFocusError: Xn,
    controlErrorWithIconRight: A,
    controlErrorWithIconLeft: ee,
    controlErrorWithIconLeftAndRight: ne,
    noLabelControlError: te,
    placemat: gt,
    noLabelPlacemat: mt,
    controlWithIconRight: Ie,
    controlWithIconLeft: ge,
    controlWithIconLeftAndRight: le,
    labelWithIconRight: Se,
    labelWithIconLeft: we,
    errorText: Le,
    errorIcon: We,
    successIcon: me,
    multiLineError: re,
    prefixWrapper: xe,
    prefixSuffix: ie,
    PrefixWrapperControl: Vn,
    prefix: Kn,
    suffix: Zn,
    noLabelSuffixOrPrefix: qn,
    prefixWrapperControlWithPrefix: Un,
    prefixWrapperControlWithSuffix: Gn,
    prefixWrapperControlWithPrefixSuffix: Jn,
    prefixWrapperFocus: Qn,
    labelWhenPlaceholderShownAndInputNotFocused: ce,
    textAreaControl: Yn,
    textAreaControlError: et,
    textAreaControlLabel: nt,
    textAreaControlErrorLabel: tt,
    textAreaCounterWrapper: rt,
    textAreaCounterWrapperFocus: at,
    textAreaCounterText: ot,
    textAreaErrorCounterWrapper: ct,
    textAreaErrorCounterWrapperFocus: lt,
    textAreaErrorCounterText: it,
    textDisplayNoLabelControl: pt,
    textDisplayControl: ut,
    textDisplayLabel: dt,
    textDisplayIconRight: bt,
    textDisplaylabelIconRight: ft,
    textDisplayControlIconRight: ht
  };
}
var Wt = ["setFocus", "className", "inputClassName", "labelClassName", "successText", "successIconAriaLabel", "errorText", "error", "errorIconAriaLabel", "helperText", "value", "name", "id", "label", "isLabelHidden", "placeholder", "placemat", "leftIcon", "rightIcon", "onChange", "children", "renderContent", "removeBorderRadiusLeft", "removeBorderRadiusRight", "removeBorderRadiusBoth", "dir", "leftIconCSS", "rightIconCSS"];
function kn(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function ve(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? kn(Object(t), !0).forEach(function(o) {
      ae(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kn(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
var Tt = function(e) {
  var n = e.messageId, t = e.helperText, o = e.errorText, d = e.errorIconAriaLabel, b = e.successText, g = e.successIconAriaLabel, u = be(), i = de(function() {
    return fe(u);
  }, [u]);
  if (o || b) {
    var r, p = o || b, O = Array.isArray(p) ? C("ul", {
      css: i.multiLineError,
      "data-ppui": "true"
    }, p.map(function(w, s) {
      return C("li", {
        key: "msg".concat(n, "-").concat(s),
        "data-ppui": "true"
      }, w);
    })) : p, h, v;
    if (o) {
      var y = {
        css: i.errorIcon,
        role: "img",
        "aria-label": d
      };
      h = C(_t, $({
        size: "sm"
      }, y, {
        "data-ppui": "true"
      }));
    }
    if (!o) {
      var S = {
        css: i.successIcon,
        role: "img",
        "aria-label": g
      };
      v = C(Ot, $({
        size: "sm"
      }, S, {
        "data-ppui": "true"
      }));
    }
    return C("div", {
      css: i.errorText,
      id: n,
      role: "alert",
      "data-ppui": "true"
    }, (r = h) !== null && r !== void 0 ? r : v, O);
  }
  if (t) {
    var _ = [i.helperText], m = Array.isArray(t) ? C("ul", {
      css: _,
      id: n,
      "data-ppui": "true"
    }, t.map(function(w, s) {
      return C("li", {
        key: "msg".concat(n, "-").concat(s),
        "data-ppui": "true"
      }, w);
    })) : C("div", {
      css: _,
      id: n,
      "data-ppui": "true"
    }, t);
    return m;
  }
  return null;
}, Hn = function(e, n, t, o) {
  return e ? C("div", {
    css: [n === "left" && o.iconLeft, n === "right" && o.iconRight, t],
    key: "icon-".concat(n),
    "data-ppui": "true"
  }, e) : null;
}, Mn = function(e) {
  var n = e.setFocus, t = e.className, o = e.inputClassName, d = e.labelClassName, b = e.successText, g = e.successIconAriaLabel, u = g === void 0 ? "Success" : g, i = e.errorText, r = e.error, p = r === void 0 ? !!i : r, O = e.errorIconAriaLabel, h = O === void 0 ? "Error" : O, v = e.helperText, y = e.value, S = e.name, _ = e.id, m = _ === void 0 ? "text-input-".concat(S) : _, w = e.label, s = e.isLabelHidden, f = e.placeholder, L = f === void 0 ? " " : f, I = e.placemat, j = e.leftIcon, T = j === void 0 ? null : j, N = e.rightIcon, M = N === void 0 ? null : N, k = e.onChange;
  e.children;
  var E = e.renderContent;
  e.removeBorderRadiusLeft, e.removeBorderRadiusRight, e.removeBorderRadiusBoth;
  var H = e.dir, P = e.leftIconCSS, D = e.rightIconCSS, F = J(e, Wt), B = be(), X = de(function() {
    return fe(B);
  }, [B]), V = [X.base], K = "message_".concat(m), Z = k ? {
    onChange: k,
    value: y
  } : {
    defaultValue: y
  }, q = v || i ? {
    "aria-describedby": K
  } : {}, R = ve(ve(ve({}, q), Z), F);
  return C("div", {
    className: t,
    css: V,
    dir: H,
    "data-ppui-info": "text-input_5.1.10"
  }, Hn(T, "left", P, X), E(ve({
    inputClassName: o,
    name: S,
    id: m,
    setFocus: n,
    hasError: p,
    placeholder: L,
    placemat: I,
    label: w,
    labelClassName: d,
    isLabelHidden: s,
    inputTag: "input",
    leftIcon: T,
    rightIcon: M
  }, R)), C(Tt, {
    errorText: i,
    errorIconAriaLabel: h,
    successText: b,
    successIconAriaLabel: u,
    helperText: v,
    messageId: K,
    "data-ppui": "true"
  }), Hn(M, "right", D, X));
}, Nt = ["inputClassName", "inputTag", "name", "id", "setFocus", "inputRef", "hasError", "placeholder", "placemat", "label", "labelClassName", "isLabelHidden", "rightIcon", "leftIcon", "prefix", "suffix"], jt = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 ? arguments[1] : void 0, t = e.length, o = n.length;
  return t >= o ? e : e.concat(n.substring(t));
}, Et = function(e) {
  var n = e.placeholder, t = e.value, o = t === void 0 ? "" : t, d = e.isLabelHidden, b = d === void 0 ? !1 : d, g = e.styles, u = jt(o, n), i = [g.placemat, b && g.noLabelPlacemat];
  return C("div", {
    css: i,
    "data-ppui": "true"
  }, u);
}, Ft = function(e) {
  var n = e ?? " ";
  return n === "" ? " " : n;
}, je = function(e) {
  var n = e.inputClassName, t = e.inputTag, o = e.name, d = e.id, b = e.setFocus, g = e.inputRef, u = e.hasError, i = e.placeholder, r = e.placemat, p = e.label, O = e.labelClassName, h = e.isLabelHidden, v = e.rightIcon, y = e.leftIcon, S = e.prefix, _ = e.suffix, m = J(e, Nt), w = be(), s = de(function() {
    return fe(w);
  }, [w]), f = !p || p === "" || h, L = [s.control, f && s.nolabelControl, v && s.controlWithIconRight, y && s.controlWithIconLeft, v && y && s.controlWithIconLeftAndRight, s.labelWhenPlaceholderShownAndInputNotFocused, u && s.errorControl, u && f && s.noLabelControlError, u && v && s.controlErrorWithIconRight, u && y && s.controlErrorWithIconLeft, u && y && v && s.controlErrorWithIconLeftAndRight, S || _ ? s.PrefixWrapperControl : null, u && f && (S || _) ? s.noLabelControlError : null, S && s.prefixWrapperControlWithPrefix, _ && s.prefixWrapperControlWithSuffix, S && _ && s.prefixWrapperControlWithPrefixSuffix], I = [s.label, v && s.labelWithIconRight, y && s.labelWithIconLeft, f && s.labelWithScreenreader], j = m.value;
  return $n(function() {
    var T = g.current;
    b && T && T.focus();
  }, [b]), C(ue.Fragment, null, !!r && C(Et, {
    placeholder: r,
    value: j,
    isLabelHidden: f,
    styles: s,
    "data-ppui": "true"
  }), C(t, $({
    className: n,
    css: L,
    name: o,
    id: d,
    ref: g,
    "aria-invalid": u,
    placeholder: Ft(i)
  }, m, {
    "data-ppui": "true"
  })), p && C("label", {
    htmlFor: d,
    id: "".concat(d, "-label"),
    className: O,
    css: I,
    "data-ppui": "true"
  }, p));
}, Rt = ["label", "id", "prefix", "suffix", "prefixClassName", "suffixClassName", "inputClassName", "inputRef", "onBlur", "onFocus", "hasError", "isLabelHidden"], At = function(e) {
  var n = e.label, t = e.id, o = e.prefix, d = e.suffix, b = e.prefixClassName, g = e.suffixClassName, u = e.inputClassName, i = e.inputRef, r = e.onBlur, p = r === void 0 ? null : r, O = e.onFocus, h = O === void 0 ? null : O, v = e.hasError, y = e.isLabelHidden, S = J(e, Rt), _ = be(), m = de(function() {
    return fe(_);
  }, [_]), w = i, s = ye(!1), f = Ce(s, 2), L = f[0], I = f[1], j = !n || n === "" || y, T = [m.prefix, j && m.noLabelSuffixOrPrefix], N = [m.suffix, j && m.noLabelSuffixOrPrefix], M = [m.prefixWrapper, L && m.prefixWrapperFocus, v && m.prefixWrapperError, v && L && m.prefixWrapperFocusError], k = n ? "".concat(t, "-label ") : "", E = o ? "".concat(t, "-prefix ") : "", H = d ? "".concat(t, "-suffix") : "", P = "".concat(k).concat(E).concat(H);
  return C("div", {
    css: M,
    onClick: function() {
      if (w.current) {
        var F = w.current;
        F.focus();
      }
    },
    "data-ppui": "true"
  }, C(je, $({
    label: n,
    id: t,
    prefix: o,
    suffix: d,
    inputClassName: u,
    inputRef: i,
    onFocus: function(F) {
      I(!0), h && h(F);
    },
    onBlur: function(F) {
      I(!1), p && p(F);
    },
    "aria-labelledby": P.trim(),
    hasError: v,
    isLabelHidden: j
  }, S, {
    "data-ppui": "true"
  })), o && C("div", {
    id: E.trim(),
    css: T,
    className: b,
    "data-ppui": "true"
  }, o), d && C("div", {
    id: H.trim(),
    css: N,
    className: g,
    "data-ppui": "true"
  }, d));
}, Pt = ["prefix", "suffix", "prefixClassName", "suffixClassName"], Bt = ["inputClassName", "name", "id", "setFocus", "hasError", "placeholder", "placemat", "label", "labelClassName", "inputTag"], Vt = Dn(function(e, n) {
  var t = e.prefix, o = e.suffix, d = e.prefixClassName, b = e.suffixClassName, g = J(e, Pt), u = pe(), i = n || u;
  return /* @__PURE__ */ ue.createElement(Mn, $({
    renderContent: function(p) {
      var O = p.inputClassName, h = p.name, v = p.id, y = p.setFocus, S = p.hasError, _ = p.placeholder, m = p.placemat, w = p.label, s = p.labelClassName, f = p.inputTag, L = J(p, Bt);
      return t || o ? /* @__PURE__ */ ue.createElement(At, $({
        inputClassName: O,
        inputTag: f,
        name: h,
        id: v,
        setFocus: y,
        inputRef: i,
        hasError: S,
        placeholder: _,
        label: w,
        labelClassName: s,
        prefix: t,
        suffix: o,
        prefixClassName: d,
        suffixClassName: b
      }, L, {
        "data-ppui": "true"
      })) : /* @__PURE__ */ ue.createElement(je, $({
        inputClassName: O,
        inputTag: f,
        name: h,
        id: v,
        setFocus: y,
        inputRef: i,
        hasError: S,
        placeholder: _,
        placemat: m,
        label: w,
        labelClassName: s
      }, L, {
        "data-ppui": "true"
      }));
    }
  }, g, {
    "data-ppui": "true"
  }));
}), kt = ["className", "minRows", "maxRows", "showCharacterCounter", "maxCharacters", "counterStatusText", "onChange", "onBlur", "onFocus", "value", "errorText", "successText"], Ht = ["inputClassName", "name", "id", "setFocus", "hasError", "placeholder", "label", "labelClassName", "inputTag", "placemat"], Te = 2, Ne = 6, Kt = Dn(function(e, n) {
  var t = e.className, o = e.minRows, d = o === void 0 ? Te : o, b = e.maxRows, g = b === void 0 ? Ne : b, u = e.showCharacterCounter, i = u === void 0 ? !1 : u, r = e.maxCharacters, p = e.counterStatusText, O = e.onChange, h = O === void 0 ? null : O, v = e.onBlur, y = v === void 0 ? null : v, S = e.onFocus, _ = S === void 0 ? null : S, m = e.value, w = e.errorText, s = e.successText, f = J(e, kt), L = be(), I = de(function() {
    return fe(L);
  }, [L]), j = xt(
    // @ts-ignore
    L.sysTypographyFieldLabelLgLineHeight
  ).split("px")[0], T = g ? Math.min(g, Ne) : Ne, N = d ? Math.max(d, Te) : Te, M = ye(m ? m.length : 0), k = Ce(M, 2), E = k[0], H = k[1], P = ye(!1), D = Ce(P, 2), F = D[0], B = D[1], X = ye(!1), V = Ce(X, 2), K = V[0], Z = V[1], q = pe(), R = n || q, he = yt(St), U = pe(0), oe = pe(j * T), ce = pe(j * N), _e = function() {
    var W = R.current;
    W.style.height = "auto";
    var x = W.scrollHeight + U.current;
    x > oe.current ? W.style.height = "".concat(oe.current, "px") : x > ce.current ? W.style.height = "".concat(x, "px") : W.style.height = "".concat(ce.current, "px");
  };
  $n(function() {
    if (R.current) {
      var W = R.current, x = W.offsetHeight, G = W.clientHeight, z = window.getComputedStyle(W), Q = Number(z.getPropertyValue("line-height").split("px")[0]), Y = Number(z.getPropertyValue("padding-bottom").split("px")[0]), A = Number(z.getPropertyValue("padding-top").split("px")[0]), ee = Number.isNaN(Q) ? j : Q, ne = Number.isNaN(Y) ? 0 : Y, te = Number.isNaN(A) ? 0 : A;
      U.current = x - G, oe.current = U.current + te + ne + ee * T, ce.current = U.current + te + ne + ee * N, _e(), B(z.direction === "rtl");
    }
  }, [N, T, m]);
  var Oe = function() {
    if (R.current) {
      var W = R.current;
      W.focus();
    }
  };
  return C(Mn, $({
    className: t,
    value: m,
    onChange: function(x) {
      var G = x.target;
      H(G.value.length), h && h(x);
    },
    onFocus: function(x) {
      Z(!0), _ && _(x);
    },
    onBlur: function(x) {
      Z(!1), y && y(x);
    },
    renderContent: function(x) {
      var G = x.inputClassName, z = x.name, Q = x.id, Y = x.setFocus, A = x.hasError, ee = x.placeholder, ne = x.label, te = x.labelClassName;
      x.inputTag, x.placemat;
      var Ie = J(x, Ht), ge = C(It, {
        "data-ppui": "true"
      }, function(me) {
        var re = me.css, xe = me.cx;
        return C(je, $({
          inputClassName: xe(G, ae({}, re(I.textAreaControl), !0), ae({}, re(I.textAreaControlError), A)),
          inputTag: "textarea",
          name: z,
          id: Q,
          setFocus: Y,
          inputRef: R,
          hasError: A,
          placeholder: ee,
          label: ne,
          labelClassName: xe(te, ae({}, re(I.textAreaControlLabel), !0), ae({}, re(I.textAreaControlErrorLabel), A))
        }, Ie, {
          "data-ppui": "true"
        }));
      });
      if (i) {
        var le = "";
        r && (le = F ? "".concat(r, "/") : "/".concat(r));
        var Se = F ? "".concat(le).concat(E) : "".concat(E).concat(le), we = wt(he, "".concat(E, " out of ").concat(r, " characters used"), p, {
          charCount: E,
          maxCharacters: r
        }), Le = [I.textAreaCounterWrapper, K && I.textAreaCounterWrapperFocus, A && I.textAreaErrorCounterWrapper, A && K && I.textAreaErrorCounterWrapperFocus], We = [I.textAreaCounterText, A && I.textAreaErrorCounterText];
        return C("div", {
          css: Le,
          onClick: Oe,
          "data-ppui": "true"
        }, ge, C("div", {
          css: We,
          role: "status",
          "aria-live": "polite",
          "aria-atomic": "true",
          "aria-label": we,
          "data-ppui": "true"
        }, Se));
      }
      return ge;
    },
    errorText: w,
    successText: s,
    "data-ppui-info": "text-area_5.1.10"
  }, f));
});
export {
  St as I,
  Vt as T,
  Kt as a,
  Xt as g
};
//# sourceMappingURL=pp-react-text-input.esm-853a9847.js.map
